/*!

=========================================================
* 顧客マスタ詳細
=========================================================
*/
import React from "react";

import {
  Button,
  Card,  CardHeader,  CardBody,  CardTitle,
  Table,  Row,  Col,
} from "reactstrap";
import { Link } from 'react-router-dom';
import Request from '../../common/Request';
import ButtonWithTooltip from '../FormParts/ButtonWithTooltip'
import CopyToClipWithSpan from '../FormParts/CopyToClipWithSpan'
import CustomTd from '../ViewParts/CustomTd';
import SystemInfo from '../ViewParts/SystemInfo';
import ApprovedInfo from '../ViewParts/ApprovedInfo';
import WithRole from '../FormParts/ButtonWithRole';
import FormatCode from '../../common/FormatCode';

const domain = "";
var tmp = [];

class Detail extends React.Component {
  constructor(props){
    super(props);
    this.state ={
      customer_id: this.props.match.params.customer_id,
      data: {
        values:{},
      },
      branch_data: [],
      user_data: [],
      customer_name: "",
      update_timestamp: "",
      customer_kana: "",
      pagetitle: "顧客マスタ情報詳細"
    };

  } 
  async componentDidMount () {
    let customer_id = this.props.match.params.customer_id;
    var url = domain + '/api/customer/'+customer_id;
    var params = {};

    Request.get(url, params, res => {
      // approvalから承認の段階の内容も表示
      const updatedData = {
        ...res.Data,
      }

      this.setState({
        data:{
          values:updatedData
        }
      });

      var url = domain + '/api/landmark/lastupdate/' + res.Data.lastupdate_user_id;
      var params = {};
      Request.get(url, params, res => {
        let tmp = this.state.data.values;
        tmp.lastupdate_user = res.Data;
        this.setState({data:{values:tmp}});
      });
    });

    var url = domain + '/api/customer/branch';
    params = {"customer_ulid":customer_id};
    Request.get(url, params, res => {
      // let invoice_list_customer_branch_name = ""
      // if ( this.state.data.values ) {
      //   const main_branch_data = res.Data.filter(data=>data.id == this.state.data.values.invoice_list_customer_branch_id)
      //   invoice_list_customer_branch_name = main_branch_data.length > 0? main_branch_data[0].customer_branch_name:""
      // }
      this.setState({
        data: {
          ...this.state.data,
          values: {
            ...this.state.data.values,
            // invoice_list_customer_branch_name : invoice_list_customer_branch_name
          }
        },
        branch_data:res.Data
      });
    })
    // スクロールバーを表示するように設定
    document.body.style.overflow = "auto";
  }


  render(props) {
    const ButtonWithTooltipWithRole = WithRole(ButtonWithTooltip, this.props.buttons)
    return (
      <>
        <div className="content">
          <Row>
            <Col md="12">
              <Card>
                <CardHeader>
                  <CardTitle tag="h3" className="float-left">{this.state.pagetitle}</CardTitle>
                  <ButtonWithTooltipWithRole
                    button_id="BTN_M1_05_03980"
                    onclick={() => { this.props.history.push("/customer/update/"+this.state.customer_id) }}
                    class="float-right btn-facebook"
                    id="tmp"
                    icon="fas fa-pen"
                    link=""
                    label="編集"
                    message={this.state.customer_id+"を編集"}
                    />                    
                </CardHeader>
                <CardBody>
                <Row>
                  <Col md="11" className="detail">
                    <Card>
                    <ApprovedInfo
                    visible={this.state.view}
                    rootData={this.state.data}
                    />    

                    <SystemInfo
                    id_title='会社ID'
                    id_value={this.state.data.values.customer_natural_id}
                    update_timestamp={this.state.data.values.update_timestamp}
                    update_user={this.state.data.values.lastupdate_user && this.state.data.values.lastupdate_user.name}
                    update_user_picture={this.state.data.values.lastupdate_user && this.state.data.values.lastupdate_user.picture}
                    visible={this.state.view} />             
                      <CardTitle tag="h4">管理情報</CardTitle>
                      <Table>
                        <tbody>
                          <tr>
                            <CustomTd label='メモ'
                              name='CUSTOMER__system_memo'
                              copy={false}
                              data={this.state.data.values}
                            />
                          </tr>
                          <tr>
                            <CustomTd label='削除フラグ'
                              name='CUSTOMER__delete_flag'
                              copy={false}
                              data={this.state.data.values} />
                          </tr>
                        </tbody>
                      </Table>                      

                      <CardTitle tag="h4" className="float-left">会社情報</CardTitle>
                      <Table>
                        <tbody>
                          <tr>
                            {/* <th rowSpan="2">会社情報</th> */}
                            <CustomTd label='会社名'
                              name='CUSTOMER__customer_name'
                              copy={false}
                              data={this.state.data.values} />
                          </tr> 
                          <tr>
                            <CustomTd label='会社名（カナ）'
                              name='CUSTOMER__customer_name_kana'
                              copy={false}
                              data={this.state.data.values} />
                          </tr>                        
                          <tr>
                            <CustomTd label='工事番号必須フラグ'
                              name='CUSTOMER__construction_number_require_flag'
                              copy={false}
                              data={this.state.data.values} />
                          </tr>
                          <tr>
                            <CustomTd label='一覧請求設定：メイン支店'
                              name='CUSTOMER__invoice_list_customer_branch_name'
                              copy={false}
                              data={this.state.data.values} />
                          </tr>
                        </tbody>
                      </Table>
                      <CardTitle tag="h4" className="float-left">顧客向けシステム利用情報</CardTitle>
                      <Table>
                        <tbody>
                         <tr>
                            <CustomTd label='顧客向け利用有無'
                              name='CUSTOMER__customer_system_use_flag'
                              copy={false}
                              colSpan="8"
                              value={FormatCode.decode("cst_customer_system_use_flag",this.state.data.values.customer_system_use_flag)}
                             />
                          </tr>
                          {this.state.data.values.customer_system_use_flag==1&&<tr>
                            <CustomTd label='顧客システム利用開始日'
                                name='CUSTOMER__customer_system_start_date'
                                copy={false}
                                colSpan="8"
                                data={this.state.data.values}
                              />
                          </tr>}
                          {this.state.data.values.customer_system_use_flag==1&&<tr>
                            <CustomTd label='顧客システム利用終了日'
                                name='CUSTOMER__customer_system_end_date'
                                copy={false}
                                colSpan="8"
                                data={this.state.data.values}
                            />
                          </tr>}
                          {this.state.data.values.customer_system_use_flag==1&&<tr>
                            <CustomTd label='承認機能利用'
                                name='CU_CUSTOMER_OPTION__approval'
                                copy={false}
                                colSpan="4"
                                data={this.state.data.values}
                            />
                            {this.state.data.values.approval==1&&
                              <CustomTd label='承認の段階'
                                  name='CU_CUSTOMER_OPTION__approval_step'
                                  copy={false}
                                  colSpan="4"
                                  data={this.state.data.values}
                              />
                            }
                          </tr>}
                          {this.state.data.values.customer_system_use_flag==1&&<tr>
                            <CustomTd label='データ閲覧制限'
                                name='CU_CUSTOMER_OPTION__data_scope'
                                copy={false}
                                colSpan="8"
                                data={this.state.data.values}
                            />
                          </tr>}
                          {this.state.data.values.customer_system_use_flag==1&&<tr>
                            <CustomTd label='会社ログインID'
                                name='CU_CUSTOMER_OPTION__customer_login_id'
                                copy={false}
                                colSpan="8"
                                value={this.state.data.values.customer_login_id}
                              />
                          </tr>}
                          {this.state.data.values.customer_system_use_flag==1&&<tr>
                            <CustomTd label='システム管理者'
                              name='CU_CUSTOMER_OPTION__admin_user_login_id'
                              copy={false}
                              colSpan="8"
                              data={this.state.data.values}
                            />
                          </tr>}
                        </tbody>
                      </Table>
                      <CardTitle tag="h4" className="float-left">支店一覧</CardTitle>
                      <Col md="11">
                          <Card>
                            <CardBody className="sub detail_sub">
                            <Table className="card-border">
                              <thead>
                                <tr>
                                  <th>支店名</th>
                                  <th style={{width:'135px'}}>TEL
                                  <ButtonWithTooltipWithRole
                                    button_id="BTN_M1_05_03990"
                                    disabled={this.state.data.values.delete_flag === 1}
                                    // onclick={() => { this.props.history.push("/customer/add/branch/"+this.state.customer_id) }}
                                    class="float-right btn-facebook"
                                    id="tmp"
                                    icon="fas fa-plus"
                                    link={`/customer/add/branch/${this.state.customer_id}`}
                                    target="_blank"
                                    label="追加"
                                    message="支店を追加"
                                    size="sm"
                                    />  
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                              {this.state.branch_data.map((prop,key) => {
                                return (
                                  <>
                                  <tr className="table-link">
                                      <td>
                                        <Link target="_blank" to={"/customer/detail/branch/"+prop.ulid}>{prop.customer_branch_name}</Link></td>
                                      <td><CopyToClipWithSpan label={prop.customer_branch_tel} value={prop.customer_branch_tel} /></td>
                                      {/* <td colSpan="2"><CopyToClipWithSpan label={prop.customer_branch_tel} value={prop.customer_branch_fax} /></td> */}
                                  </tr>
                                  </>
                                );
                              })}

                              </tbody>
                            </Table>
                          </CardBody>
                        </Card>
                        <Button onClick={() => { this.props.history.push('/customer?customer_natural_id='+this.state.data.values.customer_natural_id) }} className="float-left">一覧に戻る</Button>
                      </Col>
                    </Card>
                  </Col>

                </Row>
                </CardBody>
              </Card>
            </Col>            
          </Row>
        </div>
      </>
    );
  }
}

export default Detail;
